<template>
    <div class="l-row m-list">
        <div
            v-if="list"
            class="l-row__column"
        >
            <div
                class="m-list__item"
                :class="{'m-list__item--wrap':routerSingleName === 'alert' || routerSingleName === 'alerts-approve'}"
                v-for="(item, idx) in list"
                v-bind:key="idx"
                @click="$router.push({ name: routerSingleName, params: { id: item.id } }).catch(() => {})"
            >
                <slot name="list" :item="item"></slot>
            </div>
            <p
                v-if="list.length === 0"
                class="m-list__empty"
            >Brak informacji do wyświetlenia</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            required: true
        },
        routerSingleName: {
            type: String,
            required: true
        }
    }
}
</script>